var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-dezoom',
                        view: publicPath + 'sprite.svg#view-icon-dezoom',
                        viewBox: '0 0 55 55',
                        title: 'icons/fonctions/dezoom',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };